import { render, staticRenderFns } from "./EmdUserMenu.vue?vue&type=template&id=4b7453ce&"
import script from "./EmdUserMenu.vue?vue&type=script&lang=js&"
export * from "./EmdUserMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdUserMenu.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b7453ce')) {
      api.createRecord('4b7453ce', component.options)
    } else {
      api.reload('4b7453ce', component.options)
    }
    module.hot.accept("./EmdUserMenu.vue?vue&type=template&id=4b7453ce&", function () {
      api.rerender('4b7453ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/molecules/EmdUserMenu.vue"
export default component.exports